import React from 'react';
import { AuthPage } from '../auth/auth-page';

export const ConfirmMail = () => <AuthPage view="confirm" />;
